import api from './client';
import type { CostCenter } from './costCenters';

export enum AllocationBasis {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  UNIT_BASED = 'UNIT_BASED',
}

export enum AllocationSourceType {
  EXPENSE = 'EXPENSE',
  PURCHASE = 'PURCHASE',
  SALE = 'SALE',
  MANUAL = 'MANUAL',
}

export interface CostAllocation {
  id: string;
  costCenterId: string;
  costCenter?: CostCenter;
  sourceType: AllocationSourceType;
  sourceId: string;
  amount: number;
  percentage?: number;
  basis: AllocationBasis;
  description?: string;
  metadata?: Record<string, any>;
  effectiveDate?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCostAllocationDto {
  costCenterId: string;
  sourceType: AllocationSourceType;
  sourceId: string;
  amount: number;
  percentage?: number;
  basis: AllocationBasis;
  description?: string;
  metadata?: Record<string, any>;
  effectiveDate?: string;
}

export type UpdateCostAllocationDto = Partial<CreateCostAllocationDto>;

export interface GetCostAllocationsFilters {
  costCenterId?: string;
  sourceType?: AllocationSourceType;
  sourceId?: string;
}

export const costAllocationsApi = {
  async getCostAllocations(
    filters: GetCostAllocationsFilters = {},
  ): Promise<CostAllocation[]> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });
    const query = params.toString();
    const response = await api.get<CostAllocation[]>(
      `cost-allocations${query ? `?${query}` : ''}`,
    );
    return response.data;
  },

  async getCostAllocation(id: string): Promise<CostAllocation> {
    const response = await api.get<CostAllocation>(`cost-allocations/${id}`);
    return response.data;
  },

  async createCostAllocation(data: CreateCostAllocationDto): Promise<CostAllocation> {
    const response = await api.post<CostAllocation>('cost-allocations', data);
    return response.data;
  },

  async updateCostAllocation(
    id: string,
    data: UpdateCostAllocationDto,
  ): Promise<CostAllocation> {
    const response = await api.put<CostAllocation>(`cost-allocations/${id}`, data);
    return response.data;
  },

  async deleteCostAllocation(id: string): Promise<void> {
    await api.delete(`cost-allocations/${id}`);
  },
};

export default costAllocationsApi;
